import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";

class ChangeFontTab extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      font: "'Roboto', sans-serif",
    }
  }
  notifyChangeFontUpdatedSuccess(propertyName) {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;{propertyName} saved successfully</b>, {
      position: "top-center",

    });

  }
  notifyFailToSave(falseRes) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{falseRes}</b>, {
      position: "top-center",
      color: "red"

    });
  }
  refreshFont = (e) => {
    this.fetchFontApi();
    var fontController = this;
    if (document.getElementById("fontText") != null) {
      var widgetFontTimer = setInterval(function () {
        clearTimeout(widgetFontTimer);
        document.getElementById("fontText").style.fontFamily = fontController.state.font;
      }, 50);

    }
  }
  saveFont = (e) => {
    var fontController = this;
    var formData = {
      "projectId": localStorage.getItem("currentProjectId"),
      agentPropertyName: "WIDGET_FONT_FAMILY",

      agentPropertyValue: fontController.state.font,
    }

    $.ajax({
      url: "/api/agent-properties",
      async: false,
      method: 'POST',
      headers: {
        'Authorization': "Bearer " + localStorage.getItem("access_token"),
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(formData),
      processData: false,
      contentType: "application/json; charset=UTF-8",
      success: function (res) {
        if (res.success === true) {
          fontController.notifyChangeFontUpdatedSuccess("Font");
        } else {
          fontController.notifyFailToSave(res.result);


        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }


    })

  }
  fetchFontApi(projectId) {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var widgetFontController = this;
    $.ajax({
      url: "/api/agent-property",
      async: false,
      method: 'GET',
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: {
        projectId: projectId,
        agentPropertyName: "WIDGET_FONT_FAMILY"
      },
      success: function (res) {
        if (res.success === true) {
          var primary = "'Roboto', sans-serif";
          var sanPro = "'Source Sans Pro', sans-serif";
          var lato = " 'Lato', sans-serif ";
          var openSans = " 'Open Sans', sans-serif ";
          var ptSerif = " 'PT Serif', serif ";
          if (res.result != null) {
            var fontFamily = res.result['agentPropertyValue'];
            if (fontFamily != "") {
              widgetFontController.setState({ font: fontFamily });
              if (fontFamily === primary && document.getElementById("roboto") != null) {
                document.getElementById("roboto").checked = true;
              } else if (fontFamily === sanPro && document.getElementById("san-pro") != null) {
                document.getElementById("san-pro").checked = true;
              } else if (fontFamily === lato && document.getElementById("lato") != null) {
                document.getElementById("lato").checked = true;
              } else if (fontFamily === openSans && document.getElementById("open-sans") != null) {
                document.getElementById("open-sans").checked = true;
              } else if (fontFamily === ptSerif && document.getElementById("pt-serif") != null) {
                document.getElementById("pt-serif").checked = true;
              }
            } else {
              widgetFontController.setState({ font: primary });
              if (document.getElementById("roboto") != null) {
                document.getElementById("roboto").checked = true;
              }
            }
          }
        } else {
          widgetFontController.setState({ font: primary });
          if (document.getElementById("roboto") != null) {
            document.getElementById("roboto").checked = true;
          }
        }
      }
    });
  }
  componentDidMount() {
    var fontController = this;
    (function () {
      var ua = navigator.userAgent.toLowerCase();
      var isAndroid = ua.indexOf("android") > -1;
      if ((isAndroid) && ($(window).width() < 500)) {
        $('.boxH input').focus(function () {
          document.body.scrollTop = $(this).offset().top;
          $('.robot_box').hide(300);
        }).blur(function () {
          $('.robot_box').show(300);
        });
      }

      $('.float_btn').on("click", function () {
        $('.widget_wrapper').toggleClass('active');
        $(this).hide();
      });
      $('.clsIframebtn').on('click', function () {
        $('.widget_wrapper').removeClass('active', function () {
          $('#chat_window , #chat_window_1, #chat_window_2').removeClass('active');
        });
        $('.float_btn').show();
      });

      $('#firstScreenbtn').on('click', function () {
        $('#chat_window').removeClass('active');
        $('#chat_window_1').show(400).addClass('active');
      });

      $('#secondScreenbtn').on('click', function () {
        $('#chat_window_1').removeClass('active');
        $('#chat_window_2').show(400).addClass('active');
        $('.float_btn').show();
      });

      $('.messageInput').on('keyup', function () {
        var input = $(this);
        if (input.val().length > 0) {
          $('.mic').hide();
          $('.send').show();
        }
        else {
          $('.send').hide();
          $('.mic').show();
        }
      });



      $("#myCarousel").on("slide.bs.carousel", function (e) {
        var $e = $(e.relatedTarget);
        var idx = $e.index();
        var itemsPerSlide = 2;
        var totalItems = $(".carousel-item").length;

        if (idx >= totalItems - (itemsPerSlide - 1)) {
          var it = itemsPerSlide - (totalItems - idx);
          for (var i = 0; i < it; i++) {
            if (e.direction == "left") {
              $(".carousel-item")
                .eq(i)
                .appendTo(".carousel-inner");
            } else {
              $(".carousel-item")
                .eq(0)
                .appendTo($(this).find(".carousel-inner"));
            }
          }
        }
      });

      var primary = "'Roboto', sans-serif";
      var sanPro = "'Source Sans Pro', sans-serif";
      var lato = " 'Lato', sans-serif ";
      var openSans = " 'Open Sans', sans-serif ";
      var ptSerif = " 'PT Serif', serif ";

      $('input[name="botfont"]').on('click', function () {
        var fontval = $(this).val();

        if (fontval == 'ptSerif') {
          $('.configChatBox').css('font-family', ptSerif)
          var fontChosen = ptSerif;
        } else if (fontval == 'openSans') {
          $('.configChatBox').css('font-family', openSans)
          var fontChosen = openSans;
        } else if (fontval == 'lato') {
          $('.configChatBox').css('font-family', lato)
          var fontChosen = lato;
        } else if (fontval == 'sanPro') {
          $('.configChatBox').css('font-family', sanPro)
          var fontChosen = sanPro;
        } else {
          $('.configChatBox').css('font-family', primary)
          var fontChosen = primary;
        }
        fontController.setState({ font: fontChosen })
      });

    })();
    setTimeout(() => {
      this.fetchFontApi();
    }, 300);
    var thisController = this;
    document.addEventListener("projectChanged", function (event) {
      thisController.projectId = event.projectId;
      thisController.fetchFontApi(event.projectId);
    });

  }
  render() {

    return (
      <div >
        <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
        {/* Font Awesome Icons */}
        <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
        {/* IonIcons */}
        <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
        {/* Select2 */}
        <link rel="stylesheet" href="plugins/select2/select2.min.css" />
        {/* Theme style */}
        <link rel="stylesheet" href="assets/css/adminlte.css" />
        <link rel="stylesheet" href="assets/css/styles.css" />
        <link rel="stylesheet" href="assets/css/custom-style.css" />
        <link rel="stylesheet" href="assets/css/configBot.css" />
        <link rel="stylesheet" href="assets/css/mediaQ.css" />

        <div className="card-body">
          <div className="tab-content col-12 p-0">
            <div className="tab-pane nav-link active show">
              <ToastContainer className="Toast-at-center" />
              <div className="card-primary mt-2">
                <div className="p-2" Align="right">

                  <button type="button" className="btn action-button" title="save font" onClick={this.saveFont}> <img className="img-responsive cursor-change" src="./assets/images/baseline_save_white_24dp.png"

                  /></button>
                  <button type="button" className="btn action-button" title="refresh" onClick={this.refreshFont}> <img className="img-responsive cursor-change" src="./assets/images/refresh_white_24dp.png"

                  /></button>
                </div>
                <div className="col-lg-12 fontSelectBox">
                  <div className="radio-inline fPrimary" style={{ marginLeft: "10px", color: "black" }}>

                    <span className="pl-5 pr-5">
                      <input type="radio" name="botfont" id="roboto" defaultValue="Roboto" defaultChecked />
                    </span>
                    <div className="fp_outBox">
                      <span className="fontTitle">Roboto</span>
                      <div className="fontpreviewBox">
                        Almost before we knew it, we had left the ground.
                      </div>
                    </div>
                  </div>
                  <div className="radio-inline fSourceSanPro" style={{ color: "black" }}>
                    <span className="pl-5 pr-5">
                      <input type="radio" name="botfont" id="san-pro" defaultValue="sanPro" defaultChecked />
                    </span>
                    <div className="fp_outBox">
                      <span className="fontTitle">Source San Pro</span>
                      <div className="fontpreviewBox">
                        Almost before we knew it, we had left the ground.
                      </div>
                    </div>
                  </div>
                  <div className="radio-inline fLato" style={{ color: "black" }}>
                    <span className="pl-5 pr-5">
                      <input type="radio" name="botfont" id="lato" defaultValue="lato" defaultChecked />
                    </span>
                    <div className="fp_outBox">
                      <span className="fontTitle">Lato</span>
                      <div className="fontpreviewBox">
                        Almost before we knew it, we had left the ground.
                      </div>
                    </div>
                  </div>
                  <div className="radio-inline fOpenSans" style={{ color: "black" }}>
                    <span className="pl-5 pr-5">
                      <input type="radio" name="botfont" id="open-sans" defaultValue="openSans" defaultChecked />
                    </span>
                    <div className="fp_outBox">
                      <span className="fontTitle">Montserrat</span>
                      <div className="fontpreviewBox">
                        Almost before we knew it, we had left the ground.
                      </div>
                    </div>
                  </div>
                  <div className="radio-inline fPTserif" style={{ color: "black" }}>
                    <span className="pl-5 pr-5">
                      <input type="radio" name="botfont" id="pt-serif" defaultValue="ptSerif" defaultChecked />
                    </span>
                    <div className="fp_outBox">
                      <span className="fontTitle">PT Serif</span>
                      <div className="fontpreviewBox">
                        Almost before we knew it, we had left the ground.
                      </div>

                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default ChangeFontTab;  


// WEBPACK FOOTER //
// ./src/projectmgmt/settings/ChangeFontTab.js